export const URL_BUSCAR_TIPOS_DOCUMENTO = "/Activos/WebService/ActivosWebService.asmx/BuscarTiposDocumento";
export const URL_BUSCAR_ESTATUS_DOCUMENTO = "/Activos/WebService/ActivosWebService.asmx/BuscarEstatusDocumento";
export const URL_BUSCAR_BANCOS = "/Activos/WebService/ActivosWebService.asmx/BuscarBancos";
export const URL_BUSCAR_BANCO_DETALLES = "/Activos/WebService/ActivosWebService.asmx/BuscarBancoDetalles";
export const URL_BUSCAR_BENEFICIARIOS = "/Activos/WebService/ActivosWebService.asmx/BuscarBeneficiarios";
export const URL_BUSCAR_PERIODOS = "/CxC/WebService/CxcWebService.asmx/BuscarPeriodos";
export const URL_REPORTE_DOCUMENTOS_BANCARIOS = "/Activos/WebService/ActivosWebService.asmx/ReporteDocumentosBancarios";

export class ActivosReporteService {
  static consultar(url, opciones) {
    return new Promise(function (resolve, reject) {
      const where = opciones ? { where: { ...opciones } } : null;
      Citrus.AJAX.getJSON(url, where, function (respuesta) {
        var datos = $.parseJSON(respuesta.d);

        if (
          datos &&
          datos["Mensaje"] !== undefined &&
          datos["Detalle"] !== undefined &&
          datos["Interno"] !== undefined
        ) {
          reject(datos);
        }
        resolve(datos);
      });
    });
  }

  static consultarReporteDocumentosBancarios(where) {
    return this.consultar(URL_REPORTE_DOCUMENTOS_BANCARIOS, {
      ...where,
    }).then((res) => {
      return res;
    });
  }

  static consultarTiposDocumento() {
    return this.consultar(URL_BUSCAR_TIPOS_DOCUMENTO).then((res) => {
      return res?.Resultados;
    });
  }

  static consultarEstatusDocumento() {
    return this.consultar(URL_BUSCAR_ESTATUS_DOCUMENTO).then((res) => {
      return res?.Resultados;
    });
  }

  static consultarPeriodos() {
    return this.consultar(URL_BUSCAR_PERIODOS).then((res) => {
      return res?.Resultados;
    });
  }

  static consultarBancos() {
    return this.consultar(URL_BUSCAR_BANCOS, {
      EsPaginable: false,
      EsOrdenable: true,
      OrderBy: "Nombre",
      EsAscendente: true,
    }).then((res) => {
      return res?.Resultados;
    });
  }

  static consultarBancoDetalles(where) {
    return this.consultar(URL_BUSCAR_BANCO_DETALLES, {
      EsPaginable: false,
      ...where,
    }).then((res) => {
      return res?.Resultados;
    });
  }

  static consultarBeneficiarios() {
    return this.consultar(URL_BUSCAR_BENEFICIARIOS).then((res) => {
      return res?.Resultados;
    });
  }
}
